import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
    minHeight: 500,
  },
  titleWrapper: {
    width: '100%',
    padding: 20,
    textAlign: 'center',
    borderBottom: '1px solid #929292',
  },
  title: {
    fontSize: '20px',
    lineHeight: '23px',
  },
  main: {
    width: '90%',
    padding: '25px 0',
  },
  webViewMain: {
    paddingBottom: 220,
  },
  formControl: {
    backgroundColor: theme.backgrounds.cardBackground,
    width: '100%',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
  },
  typeMenuItem: {
    backgroundColor: theme.backgrounds.cardBackground,
  },
  webView: {
    background: theme.webView.background,
  },
}))

export default useStyles
